/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseListingsItemResponse } from './ResponseListingsItemResponse';
import {
    ResponseListingsItemResponseFromJSON,
    ResponseListingsItemResponseFromJSONTyped,
    ResponseListingsItemResponseToJSON,
    ResponseListingsItemResponseToJSONTyped,
} from './ResponseListingsItemResponse';

/**
 * 
 * @export
 * @interface ResponseListingsItemsResult
 */
export interface ResponseListingsItemsResult {
    /**
     * 
     * @type {Array<ResponseListingsItemResponse>}
     * @memberof ResponseListingsItemsResult
     */
    items?: Array<ResponseListingsItemResponse>;
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemsResult
     */
    nextToken?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseListingsItemsResult
     */
    numberOfResults?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemsResult
     */
    previousToken?: string;
    /**
     * 商品キャッシュが空のため、検索ではなくバックグラウンド同期を開始した（items は空）
     * @type {boolean}
     * @memberof ResponseListingsItemsResult
     */
    syncStarted?: boolean;
}

/**
 * Check if a given object implements the ResponseListingsItemsResult interface.
 */
export function instanceOfResponseListingsItemsResult(value: object): value is ResponseListingsItemsResult {
    return true;
}

export function ResponseListingsItemsResultFromJSON(json: any): ResponseListingsItemsResult {
    return ResponseListingsItemsResultFromJSONTyped(json, false);
}

export function ResponseListingsItemsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListingsItemsResult {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ResponseListingsItemResponseFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'numberOfResults': json['numberOfResults'] == null ? undefined : json['numberOfResults'],
        'previousToken': json['previousToken'] == null ? undefined : json['previousToken'],
        'syncStarted': json['syncStarted'] == null ? undefined : json['syncStarted'],
    };
}

export function ResponseListingsItemsResultToJSON(json: any): ResponseListingsItemsResult {
    return ResponseListingsItemsResultToJSONTyped(json, false);
}

export function ResponseListingsItemsResultToJSONTyped(value?: ResponseListingsItemsResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ResponseListingsItemResponseToJSON)),
        'nextToken': value['nextToken'],
        'numberOfResults': value['numberOfResults'],
        'previousToken': value['previousToken'],
        'syncStarted': value['syncStarted'],
    };
}

